import { createSlice } from '@reduxjs/toolkit';
import Auth from '@aws-amplify/auth'
import Amplify from "aws-amplify";

console.log('CURRENT API', process.env.REACT_APP_API_ENDPOINT);

export let API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT ?? "6b5bwk6r3c.execute-api.ap-southeast-2.amazonaws.com"
export const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL ?? "https:"

export let API_REGION = process.env.REACT_APP_API_REGION ?? "ap-southeast-2"
export const API_STAGE = process.env.REACT_APP_API_STAGE ?? "/Prod"
export let SCOUT_API_ENDPOINT = process.env.REACT_APP_SCOUT_API_ENDPOINT ?? ""
export const SCOUT_API_PROTOCOL = process.env.REACT_APP_SCOUT_API_PROTOCOL ?? API_PROTOCOL
export let SCOUT_API_REGION = process.env.REACT_APP_SCOUT_API_REGION ?? API_REGION
export let SCOUT_API_STAGE = process.env.REACT_APP_SCOUT_API_STAGE ?? API_STAGE
export let ERP_API_ENDPOINT = process.env.REACT_APP_ERP_API_ENDPOINT ?? ""
export const ERP_API_PROTOCOL = process.env.REACT_APP_ERP_API_PROTOCOL ?? API_PROTOCOL
export let ERP_API_REGION = process.env.REACT_APP_ERP_API_REGION ?? API_REGION
export let ERP_API_STAGE = process.env.REACT_APP_ERP_API_STAGE ?? API_STAGE

export let SOCKET_HOST = process.env.REACT_APP_SOCKET_HOST ?? "50pjbpshmb.execute-api.ap-southeast-2.amazonaws.com"

initRegion();

const initialState = {
    isLoading: false,
    isAuthenticated: false,
    user: null

};

function initRegion() {
    if (localStorage.getItem("eu") && localStorage.getItem("eu") === "true") {
        API_ENDPOINT = process.env.REACT_APP_EU_API_ENDPOINT ?? "58m8c3bu61.execute-api.eu-west-2.amazonaws.com"
        API_REGION = process.env.REACT_APP_EU_API_REGION ?? "eu-west-2"
        SCOUT_API_ENDPOINT = process.env.REACT_APP_EU_SCOUT_API_ENDPOINT ?? SCOUT_API_ENDPOINT
        SCOUT_API_STAGE = process.env.REACT_APP_EU_SCOUT_API_STAGE ?? SCOUT_API_STAGE
        SCOUT_API_REGION = process.env.REACT_APP_EU_SCOUT_API_REGION ?? SCOUT_API_REGION
        ERP_API_ENDPOINT = process.env.REACT_APP_EU_ERP_API_ENDPOINT ?? ERP_API_ENDPOINT
        ERP_API_STAGE = process.env.REACT_APP_EU_ERP_API_STAGE ?? ERP_API_STAGE
        ERP_API_REGION = process.env.REACT_APP_EU_ERP_API_REGION ?? ERP_API_REGION
        SOCKET_HOST = process.env.REACT_APP_EU_SOCKET_HOST ?? "r0n011h93g.execute-api.eu-west-2.amazonaws.com"
    }
}

const slice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        // LOGIN
        onSignIn(state, action) {
            state.isAuthenticated = true;
            state.user = action.payload.user;
            console.log("User signed in", state.user)
        },
        onTest(state, action) {
            state.isAuthenticated = true;
            state.user = action.payload.user
        },
        updateUserProfile(state, action) {
            console.log("USE!", action.payload)
            state.isAuthenticated = true;
            state.profile = action.payload.profile
        }
    }
});

// Reducerinde
export default slice.reducer;


export function checkUserSession() {
    return function (dispatch) {
        dispatch({ type: 'API_LOADING' })
        return new Promise(async (resolve, reject) => {
            Auth.currentAuthenticatedUser()
                .then(async (data) => {
                    console.log("has user", data)
                    dispatch(slice.actions.onSignIn({ user: data }))
                    resolve()
                })
                .catch(async (err) => {
                    console.log("ERROR", err)
                    if (err == "The user is not authenticated") {
                        console.log("Check for stored p/w")
                        const pw = window.localStorage.getItem("frigid")
                        if (pw && pw != "") {
                            try {
                                let newUser = await Auth.signIn(pw.split("||FRIGID||")[0], pw.split("||FRIGID||")[1])
                                console.log("newUser", newUser)
                                dispatch(slice.actions.onSignIn({ user: newUser }))
                    resolve()
                            } catch (e) {
                                dispatch(slice.actions.onSignIn({ user: null }))
                                resolve()
                            }
                        } else {
                            dispatch(slice.actions.onSignIn({ user: null }))
                            resolve()
                        }
                    } else {
                        dispatch(slice.actions.onSignIn({ user: null }))
                        resolve()
                    }
                });
        })

    }

}

export function signOut() {
    return function (dispatch) {
        return new Promise(async (resolve, reject) => {
            localStorage.removeItem("eu")
            await Auth.signOut()
            dispatch(slice.actions.onSignIn({ user: null }))
            resolve()
        })
    }
}
